import { useQuery } from 'react-query';
import { QueryListParams } from '.';
import { SharedReport } from './sharedReports/types';
import React from 'react';
import { EXPRESS_API } from 'configs/api/expressApi';

export const getSharedReports = async ({
  page = 0,
  size = 10,
  search,
  senderId = null,
  sort,
}: QueryListParams) => {
  const start = page * size;
  const params = {
    start,
    limit: size,
    search,
    sort,
    senderId,
  };

  const response = await EXPRESS_API.get(`/shared-reports`, {
    params,
  });

  return response.data;
};

export const getSenders = async () => {
  const response = await EXPRESS_API.get(`/shared-reports/senders`);

  return response.data;
};

export const deleteSharedReport = async (id: number) => {
  const response = await EXPRESS_API.delete(`/shared-reports/${id}`);

  return response.data;
};

export const useSharedReportsQuery = ({
  params,
  filter,
  enabled,
}: {
  params: QueryListParams;
  filter: QueryListParams;
  enabled: boolean;
}) => {
  const { data, refetch, isLoading } = useQuery(
    ['shared-reports', filter],
    async () => {
      return await getSharedReports(params).catch(ex => {
        throw ex;
      });
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      enabled: enabled,
    }
  );

  const { count, sharedReports } = data || {
    count: 0,
    sharedReports: [],
  };

  return {
    count,
    sharedReports: sharedReports as SharedReport[],
    refetch,
    isLoading,
  };
};

export const useSharedReportSenderQuery = ({
  enabled,
}: {
  enabled: boolean;
}) => {
  const { data, refetch, isLoading } = useQuery(
    ['shared-reports-senders'],
    async () => {
      return await getSenders().catch(ex => {
        throw ex;
      });
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      enabled: enabled,
    }
  );

  const emptyArrayForSenders = React.useMemo(() => [], []);
  return {
    senders: data || emptyArrayForSenders,
    refetch,
    isLoading,
  };
};
